module.exports = __webpack_public_path__ + "static/media/contractRenewal.fb36ca92.svg";